export default {
  gaId: 'UA-3593627-1',
};



// WEBPACK FOOTER //
// ./app/config/analytics.js